/* eslint-disable no-unused-vars */
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import {
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
} from '@chakra-ui/react';
import { MagnifyingGlass, X } from 'phosphor-react';

interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  label: string;
  placeholder?: string;
  delay?: number;
  width?: string;
}

export const SearchField = ({
  value,
  onChange,
  label,
  placeholder = 'Buscar',
  delay = 300,
  width = '256px',
}: SearchFieldProps) => {
  const [text, setText] = useState(value);
  const [debounced, setDebounced] = useState(value);
  const onChangeRef = useRef(onChange);
  const syncingRef = useRef(false);
  const previousValueRef = useRef(value);
  onChangeRef.current = onChange;

  useEffect(() => {
    const timeout = setTimeout(() => setDebounced(text), delay);
    return () => clearTimeout(timeout);
  }, [text, delay]);

  useLayoutEffect(() => {
    if (previousValueRef.current === value) return;
    previousValueRef.current = value;
    syncingRef.current = true;
    setText(value);
    setDebounced(value);
  }, [value]);

  useEffect(() => {
    if (syncingRef.current) {
      if (debounced === value) syncingRef.current = false;
      return;
    }
    if (debounced !== value) onChangeRef.current(debounced);
  }, [debounced, value]);

  return (
    <InputGroup w={width} maxW="100%" size="sm">
      <InputLeftElement pointerEvents="none" h="34px" w="34px" color="content.subtle">
        <MagnifyingGlass size={14} />
      </InputLeftElement>
      <Input
        type="text"
        size="sm"
        pl="34px"
        pr={text ? '34px' : '12px'}
        placeholder={placeholder}
        aria-label={label}
        value={text}
        onChange={(event) => {
          syncingRef.current = false;
          setText(event.target.value);
        }}
      />
      {text && (
        <InputRightElement h="34px" w="34px">
          <IconButton
            aria-label="Limpar busca"
            icon={<X size={12} />}
            size="xs"
            w="22px"
            h="22px"
            minW="22px"
            variant="ghost"
            color="content.subtle"
            onClick={() => {
              syncingRef.current = false;
              setText('');
            }}
          />
        </InputRightElement>
      )}
    </InputGroup>
  );
};
